export default {
    overtimeRequest: 'Overtime request',
    searchByEmployeeName: 'Search by Employee Name, ID',
    search: 'Search',
    allStatus: 'All Status',
    pending: 'Pending',
    approve: 'Approve',
    reject: 'Reject',
    no: 'No.',
    employeeNo: 'Employee ID',
    employeeName: 'Employee Name',
    requestDate: 'Request Date',
    group: 'Group',
    department: 'Department',
    inquiry: 'Inquiry',
    headDepartmentApproval: 'HOD Approval',
    status: 'Status'
}
